//  @/store/modules/vendors.js
import Vue from 'vue'

const state = {
  headers: [
    {
      value: 'name',
      text: 'Fournisseur',
      values: ["name", "fournisseur"],
    },
    {
      value: 'categories',
      text: 'Catégories',
      values: ["categories"],
    },
    {
      value: 'link',
      text: 'Lien',
      values: ["link"],
    },
    {
      value: 'url',
      text: 'Adresse',
      values: ["url"],
    },
  ],
  items: [],
}

const mutations = {
  SET_LISTENER (state, listener) {
    state.listener = listener
  },
  SET_ITEM (state, doc) {
    const data = doc.data()
    state.items = {
      ...state.items, 
      [doc.id]: data
    }
  },
  UPDATE_ITEM (state, doc) {
    state.items[doc.id] = doc.data()
  },
  DELETE_ITEM (state, doc) {
    Vue.delete(state.items, doc.id)
  },
}

const getters = {
  select: state => {
    return Object.entries(state.items).map(vendor => {
      return {
        value: vendor[0],
        text: vendor[1].name,
      }
    })
  },
}

const actions = {
  async init({ commit, state, rootState }) {
    commit('SET_LISTENER', 
    rootState.db.collection('vendors').onSnapshot(function(snapshot) {
      let changes = snapshot.docChanges()
      changes.forEach(change => {
        let type = change.type
        let doc = change.doc
        
        if(type === 'added') commit('SET_ITEM', doc)
        else if(type === 'modified') commit('UPDATE_ITEM', doc)
        else if(type === 'removed') commit('DELETE_ITEM', doc)
      })
    }, (error) => {console.log(error.message)}))
  },
  async add({ rootState }, data) {
    let response = await rootState.db.collection('vendors').add(data)
    return response
  },
  async set({ rootState }, data) {
    let ref = Boolean(data[0]) ? rootState.db.collection('vendors').doc(data[0]) : rootState.db.collection('vendors').doc()
    let response = await ref.set(data[1])
    return response
  },
  async update({ rootState }, data) {
    let ref = rootState.db.collection('vendors').doc(data[0])
    let response = await ref.update(data[1])
    return response
  },
  async delete({ rootState }, id) {
    let response = await rootState.db.collection('vendors').doc(id).delete()
    return response
  },
  async close({ rootState }) { 
    let response = await rootState.db.collection('vendors').onSnapshot(() => {})
    return response
  },
}

export default { 
  namespaced: true, state, mutations, getters, actions
}